// extracted by mini-css-extract-plugin
export default {"date-container":"date-container","info-txt":"info-txt"};